export const MORE_BOARDS_ITEM_INDEX = -2;
export const MAKE_FIRST_ITEM_INDEX = -1;
